module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('server-side-data-table', {
    attrs: {
      "url": this.url,
      "columns": this.columns,
      "extras-column-name": _vm.trans('columns.actions'),
      "storage-key": "mailtemplates-index"
    },
    scopedSlots: _vm._u([{
      key: "extras",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "btn-group"
        }, [_c('a', {
          staticClass: "btn btn-warning btn-sm",
          class: {
            disabled: !_vm.canEdit()
          },
          attrs: {
            "href": _vm.route('mailtemplates.edit', row.data.id)
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(" " + _vm._s(_vm.trans('messages.edit')) + "\n        ")])])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b55a403"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Mailtemplates.vue
// module id = 130
// module chunks = 0